var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center"},[_c('div',{staticStyle:{"width":"14px"},style:(`fill: ${_vm.iconColor}`)},[_c('svg',{attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":_vm.mdiCheckCircle}})])]),_vm._v(" "),_c('div',{staticClass:"text-sm",style:(`color: ${_vm.textColor}`)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }